module.exports = __webpack_public_path__ + "static/img/logo_024.bc900a19.png";